module.exports = __webpack_public_path__ + "img/64.c285a39f.jpg";